// Do not delete this file, even if it is not used.
// The recent ts compiler fails, if it doesn't have a separate entrypoint specified in tsconfig.json

// import modernizr if you need it (just activate the following statement). Build can be configured in .modernizrrc.js
// import modernizr from 'modernizr';

import 'bootstrap';

import './Modules/Accordion.js';
import './Modules/BannerDatenschutz.js';
import './Modules/GoogleMap.js';
import './Modules/HeaderCarousel.js';
import './Modules/Instafeed.init.js';
import './Modules/Inspirations.js';
import './Modules/Highlights.js';
import './Modules/Contact';
import './Modules/Lazysizes.js';
import './Modules/MailformElement.js';
import './Modules/MainNav.js';
import './Modules/OffCanvasNav.js';
import './Modules/MapContacts.js';
import './Modules/Namespaces.js';
import './Modules/Newshall.js';
import './Modules/PagePreloader.js';
// import './Modules/Picturefill.js';
import './Modules/ProductUpdates.js';
import './Modules/SearchBox.js';
import './Modules/StickyHeader.js';
import './Modules/VideoParalax.js';
import './Modules/ObjectFitFix.js';
import './Modules/FeManager.js';
import './Modules/Login.js';
import './Modules/Lightbox';
import './Modules/Print.js';
import './Modules/Hyphenation';
import './Modules/ImageSlider';
import './Modules/NewsTeaser';
import './Modules/Stage';
// import './Modules/Menu';



const initMenu = async () => {
    
    const {default: Menu} = await import('./Modules/Menu');

    Menu();

};
initMenu();